export function getGoogleMaps() {
  return new Promise((resolve) => {
    //@ts-ignore
    window.resolveGoogleMapsPromise = () => {
      resolve(window.google);
      //@ts-ignore
      delete window.resolveGoogleMapsPromise;
    };
    const yolo = document.getElementById("googleMapsScript");
    if (yolo === null) {
      const script = document.createElement("script");
      script.id = "googleMapsScript";
      const API = "AIzaSyBvOJTJVb_y2wUZ1o_ltVSL9elLFXWbBp4";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${API}&callback=resolveGoogleMapsPromise&libraries=visualization,drawing`;
      script.async = true;
      // const script2 = document.createElement("script");
      // script2.id = "chartsScript";
      //script2.src = `"text/javascript" src="https://www.gstatic.com/charts/loader.js"`;
      // script2.async = true;
      document.body.appendChild(script);
      //document.body.appendChild(script2);
    }
  });
}
